import { render, staticRenderFns } from "./IconTable.vue?vue&type=template&id=57efab55&scoped=true"
import script from "./IconTable.vue?vue&type=script&lang=js"
export * from "./IconTable.vue?vue&type=script&lang=js"
import style0 from "./IconTable.vue?vue&type=style&index=0&id=57efab55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57efab55",
  null
  
)

export default component.exports